import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { map } from 'rxjs/operators';

import { GlobalService } from '@app/services/global.service';

@Component({
  selector: 'app-pdo-mode-status',
  templateUrl: './pdo-mode-status.component.html',
  imports: [AsyncPipe],
})
export class PdoModeStatusComponent {
  private globalService = inject(GlobalService);

  status$ = this.globalService.systemInformation$.pipe(
    map((systemInformation) => {
      const startOptions = systemInformation.startOptions;
      if (startOptions) {
        if (startOptions.driver === 'spoe') {
          return `SPoE (${startOptions.pdoMode})`;
        } else if (startOptions.driver === 'soem') {
          return 'EtherCAT';
        }
      }
      return 'N/A';
    }),
  );
}
